import {
  CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  CUSTOMER_PORTAL_COMPONENT,
} from 'eventsTracking/constants';
import { trackEvent } from '@raisin/events-tracking';
import { CustomerPortalEvent } from 'eventsTracking/types';
/**
 * Contains all RAF Page events.
 */
export const RAF_EVENTS = {
  RAF_LINK_COPIED: (distributorId: string, bacNumber?: string) =>
    ({
      ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
      eventName: 'raf_link_copied',
      object: 'raf_link',
      action: 'copied',
      context: 'bonus',
      description: 'User clicked on copy RaF link on the RaF page (/refer-a-friend/).',
      bipsDomain: 'base',
      component: CUSTOMER_PORTAL_COMPONENT.REFER_A_FRIEND,
      customerGroup: distributorId,
      customAttribute1: bacNumber,
    } as CustomerPortalEvent),
};

/**
 *
 * @param RAF_EVENTS
 * @returns method to trigger event on RAF page Copy Link Click.
 */
export const onRafLinkCopiedHandler = ({
  distributorId,
  bacNumber,
}: {
  distributorId: string;
  bacNumber?: string | null;
}) => {
  trackEvent(RAF_EVENTS.RAF_LINK_COPIED(distributorId, bacNumber ?? undefined), true);
};
